import { render, staticRenderFns } from "./know.vue?vue&type=template&id=839a3444&scoped=true&"
import script from "./know.vue?vue&type=script&lang=js&"
export * from "./know.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839a3444",
  null
  
)

export default component.exports